define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var BaseModel = require('common/base.model');
    var server = require('server');
    var user = require('user');
    var formatter = require('common/formatter');
    var serverUtil = require('util/server.util');

    module.exports = BaseModel.extend({

        sync: function(method) {
            if (method === 'read') {
                return this.getConfirmDate();
            }
        },

        parse: function(response) {
            return response.data;
        },

        getConfirmDate: function() {
            return server.send({
                ID: 35589,
                description: 'Get last beneficial owner confirm date',
                responses: [35590, 35591]
            });
        },

        setTag: function() {
            var deferred = $.Deferred();
            var resolve = deferred.resolve.bind(deferred);
            var reject = deferred.reject.bind(deferred);
            var loginUseEmail = user.get('loginUseEmail');
            var playerName = loginUseEmail ? user.get('email') : user.get('userName');
            var tagName = 'sc/verification/beneficialAccountConfirmation';
            var tagValue = 'approved';

            var updateTagRequest = {
                tags: [{
                    name: tagName,
                    value: tagValue,
                    type: 'text'
                }],
                ID: 35544,
                responses: [35545, 35546],
                description: 'Set tag'
            };

            return serverUtil.sendBatchRequest(
                [updateTagRequest], { useEmail: loginUseEmail, playerName: playerName })
                .done(resolve)
                .fail(reject);
        },

        setConfirmDate: function() {
            var formatDate = formatter.getDateForIms(new Date());
            var setPaymentsUserInfoRequest = {
                ID: 35586,
                lastBeneficialOwnerConfirmDate: formatDate,
                responses: [35587, 35588],
                description: 'Set confirmation date'
            };

            return server.send(setPaymentsUserInfoRequest);
        }

    });
});
